import React from "react";
import {
  SearchBarSection,
  IconSection,
  CardSection,
  ResourceCard,
} from "./styles";
import { SearchBar } from "../../components/SearchBar";
import { Resource } from "../../components/Resource";
import { Menu } from "../../components/Menu";
import Spinner from "../../components/Spinner/Spinner";
import { getResourcesList } from "../../services/resources/getResources";
import { getCategoriesList } from "../../services/categories/getCategories";
import { ROUTES } from "../../routes/constants";
import { ResourceSkeleton } from "../../components/ResourceSkeleton";
import { useNavigate } from "react-router-dom";
import { NullDescription, NullMessage, NullPage } from "../Reservations/styles";

const Reserve = () => {
  // ------------------- JWT -------------------
  const jwt = localStorage.getItem("jwt");
  const userType = localStorage.getItem("user_type");

  const navigate = useNavigate();
  // ------------------- REMOVE THIS -------------------
  const images = [
    "https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg",
    "https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg",
    "https://images.unsplash.com/photo-1554260570-e9689a3418b8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2364&q=80",
    "https://images.unsplash.com/photo-1614028674026-a65e31bfd27c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80",
    "https://images.unsplash.com/photo-1564038057903-1d48b852b412?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80",
  ];

  // ------------------- STATES -------------------
  const [loadingResources, setLoadingResources] = React.useState(false); // Loading state
  const [loadingCategories, setLoadingCategories] = React.useState(false); // Loading state
  const [resourcesList, setResourcesList] = React.useState<any>([]); // Resources list state
  const [mainResourcesList, setMainResourcesList] = React.useState<any>([]); // Resources list state
  const [categoriesList, setCategoriesList] = React.useState<any>([]); // Categories list state

  // ------------------- USE EFFECT -------------------
  React.useEffect(() => {
    getCategories();
    getResources();
  }, []);

  React.useEffect(() => {
  }, [resourcesList]);

  React.useEffect(() => {
  }, [categoriesList]);

  React.useEffect(() => {
    if (categoriesList.length > 0) {
      handleCategorySelect(categoriesList[0].name);
    }
  }, [categoriesList, mainResourcesList]);

  // React.useEffect(() => {
  //   if (resourcesList.length > 0) {
  //     setLoadingResources(true);
  //   }
  // }, [resourcesList]);

  // ------------------- GET RESOURCES FROM API -------------------
  const getResources = async () => {
    await getResourcesList(jwt!)
      .then((res) => {
        if (res && res.data) {
          setMainResourcesList(res.data);
        }
        setLoadingResources(true);
      })
      .catch((err) => {});

  };

  const getCategories = async () => {
    await getCategoriesList(jwt!)
      .then((res) => {
        if (res && res.data) {
          setCategoriesList(res.data);
        }
        setLoadingCategories(true);
      })
      .catch((err) => {});

  };

  // ------------------- HANDLE FUNCTIONS -------------------
  const handleSearch = (query: string) => {
    // Verificar si la cadena de consulta no está vacía
    if (query.trim() !== "") {
      const filtered = mainResourcesList.filter(
        (resource: any) =>
          resource.name.toLowerCase().includes(query.toLowerCase()) ||
          resource.category.toLowerCase().includes(query.toLowerCase()) ||
          resource.description.toLowerCase().includes(query.toLowerCase()) ||
          resource.resource_type.toLowerCase().includes(query.toLowerCase())
      );
      setResourcesList(filtered);
    } else {
    }
  };

  const handleCategorySelect = (categoryName: string) => {
    const filteredResources = mainResourcesList.filter(
      (resource: any) => resource.category === categoryName
    );
    setResourcesList(filteredResources);
  };

  const numberOfSkeletons = 15;

  return (
    <>
      {loadingResources && loadingCategories ? (
        <div>
          <SearchBarSection>
            <SearchBar onSearch={handleSearch} />
          </SearchBarSection>

          <IconSection>
            <Menu
              categories={categoriesList}
              onCategorySelect={handleCategorySelect}
            />
          </IconSection>

          <CardSection>
            {categoriesList.length > 0 && resourcesList.length > 0 ? (
              resourcesList.map((resource: any) => (
                <ResourceCard key={resource.id}>
                  <Resource
                    key={resource.id}
                    name={resource.name}
                    description={resource.description}
                    images={
                      resource.images.length > 0
                        ? resource.images.map((img: any) => img.url)
                        : images
                    }
                    resourceId={resource.id}
                    onClick={() => navigate(`${ROUTES.DETAILS}/${resource.id}`)}
                    location={resource.location}
                  />
                </ResourceCard>
              ))
            ) : (
              <NullPage>
                <NullMessage>No hay recursos disponibles</NullMessage>
                <NullDescription>
                  Lo sentimos, por el momento no hay recursos disponibles con
                  las características establecidas
                </NullDescription>
              </NullPage>
            )}
          </CardSection>
        </div>
      ) : (
        <>
          <SearchBarSection>
            <SearchBar onSearch={() => null} />
          </SearchBarSection>

          <IconSection>
            <Menu categories={categoriesList} onCategorySelect={() => null} />
          </IconSection>

          <CardSection>
            {Array.from({ length: numberOfSkeletons }, (_, index) => (
              <ResourceCard>
                <ResourceSkeleton />
              </ResourceCard>
            ))}
          </CardSection>
        </>
      )}
    </>
  );
};

export default Reserve;
